import { render, staticRenderFns } from "./QrSection.vue?vue&type=template&id=dc82be36&scoped=true"
import script from "./QrSection.vue?vue&type=script&lang=js"
export * from "./QrSection.vue?vue&type=script&lang=js"
import style0 from "./QrSection.vue?vue&type=style&index=0&id=dc82be36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc82be36",
  null
  
)

export default component.exports